module.exports = __webpack_public_path__ + "static/img/fish101.310db75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish101.png
// module id = ayHb
// module chunks = 0